/**
 * @namespace {BX.UI}
 */
export default class LabelSize
{
	static MD = 'ui-label-md';
	static SM = 'ui-label-sm';
	static LG = 'ui-label-lg';
}